import { Cascader } from 'antd';
import React, { useEffect, useState } from 'react';
import { find, ifElse, is, last, prop, propEq } from 'ramda';
import { isNotNilOrEmpty } from 'ramda-adjunct';
import { useDocumentContext } from '../../../../context/Document';
import widgetCascaderFormatter from '../../../../lib/widgetCascaderFormatter';
import withUser from '../../../../withUser';
import { usePasteGuard } from '../../../../hooks';
import ModalChangeWidgetRules from './ModalChangeWidgetRules';

const SelectWidget = ({
  updateWidget,
  rowIndex,
  index,
  widgetId,
  itemPathPrefix,
  setIsDynamicTableInSection,
  userCanEdit,
  rules,
  className
}) => {
  const [showModalWhenNeedValidationRules, setShowModalWhenNeedValidationRules] = useState(false);
  const [widgetToChangeWithRules, setWidgetToChangeWithRules] = useState(null);
  const { searchValue, open, handleSearch, handleKeyDown, handlePaste, handleDropdownVisibleChange, resetOnSelect } = usePasteGuard();

  const {
    values, allRulesAreValid, widgets
  } = useDocumentContext();

  const updateShowModalAndWidgetToUpdate = (v) => {
    setWidgetToChangeWithRules(v);
    setShowModalWhenNeedValidationRules(!showModalWhenNeedValidationRules);
  };

  const widget = find(propEq(widgetId, 'id'))(widgets);
  useEffect(() => {
    if (isNotNilOrEmpty(widget)) {
      const regex = /"type":"dynamicTable"/gi;
      const isWidgetDynamicTable = regex.test(prop('contents', widget));

      setIsDynamicTableInSection(isWidgetDynamicTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [widget]);

  const currentDocumentOrientation = prop('orientation', values);
  const offerWidgets = widgetCascaderFormatter(widgets, currentDocumentOrientation);

  const changeWidget = (v) => ifElse(
    is(Array),
    () => updateWidget(rowIndex, index, last(v)),
    () => updateWidget(rowIndex, index, undefined)
  )(v);

  const handleChange = (value) => {
    resetOnSelect();
    setIsDynamicTableInSection(false);
    if (isNotNilOrEmpty(rules) && allRulesAreValid) {
      updateShowModalAndWidgetToUpdate(value);
    } else {
      changeWidget(value);
    }
  };

  const filter = (input, path) => path.some((option) => prop('label', option).toLowerCase().indexOf(input.toLowerCase()) > -1);
  return (
    <>
      <ModalChangeWidgetRules
        visible={showModalWhenNeedValidationRules}
        onHide={() => updateShowModalAndWidgetToUpdate(null)}
        onClick={() => {
          changeWidget(widgetToChangeWithRules);
          updateShowModalAndWidgetToUpdate(null);
        }}
      />
      <div className={className} onPaste={handlePaste} onKeyDown={handleKeyDown}>
        <Cascader
          options={offerWidgets}
          placeholder="Sélectionner un widget"
          searchValue={searchValue}
          onSearch={handleSearch}
          onChange={handleChange}
          className="cascader-widgets w-full"
          expandTrigger="hover"
          data-item-path={[...itemPathPrefix, rowIndex, index]}
          data-item-key="selected"
          value={widget ? prop('name', widget) : null}
          showSearch={{ filter }}
          disabled={!userCanEdit}
          open={open}
          onDropdownVisibleChange={handleDropdownVisibleChange}
        />
      </div>
    </>
  );
};

export default withUser(SelectWidget);
